import React, { useEffect, useState } from "react";
import axios from "axios";
import "../CSS/Services1.css";

const Service1 = ({ title }) => {
  const [services, setServices] = useState([]);
  const [currentSubtitleIndex, setCurrentSubtitleIndex] = useState(0);

  useEffect(() => {
    const fetchFilteredServices = async () => {
      try {
        const response = await axios.get(
          "https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getServicesSection1",
          {
            params: { title },
          }
        );
        setServices(response.data);
        console.log("responseofservice1:", response.data);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchFilteredServices();
  }, [title]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSubtitleIndex((prevIndex) =>
        services[0]?.subtitles2
          ? (prevIndex + 1) % services[0].subtitles2.length
          : 0
      );
    }, 8000); 

    return () => clearInterval(interval);
  }, [services]);

  return (
    <div className="section-services1">
      {services.map((service, index) => (
      <div  key={index} className="container">
        <div className="row justify-content-center text-center">
          <div className="col-md-10 col-lg-8">
            <div className="header-section">
              <h2 className="title blackthemegradient">{service.title}</h2>
              <p className="description text-white">{service.description}</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
          {service.subtitles2.length > 0 && (
              <div className="tips-section1">
                <div className="tips-section__content1 glassmorphism1">
                  <h1 className="tips-heading1 mb-4 text-center blackthemegradient">
                  {service.subtitles2[currentSubtitleIndex]?.subtitle}
                  </h1>
                  <p className="tips-description1 text-justify text-white">
                  {
                        service.subtitles2[currentSubtitleIndex]
                          ?.subdescription
                      }
                  </p>
                </div>
                <div className="tips-section__image1">
                <img
                      src={
                        service.subtitles2[currentSubtitleIndex]?.subimage || ""
                      }
                      alt={
                        service.subtitles2[currentSubtitleIndex]?.subtitle || ""
                      }
                      className="subtitle-image"
                    />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    ))}
    </div>
  );
};

export default Service1;
